module.exports = __webpack_public_path__ + "static/img/13.952db9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/eng/13.png
// module id = C+br
// module chunks = 0